// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  domain : 'ableequipment.com',
  clientPortalKey :'$2a$12$JfK04aWoW6b9WNxsWUvmdeHGTpaJjHavs971UHC.YIp0183tmXDBe',
  ableAdminEmail:'admin@sixlogs.com',
  ableAdminPassword:'Sopro@123',
  // baseUrlClientPortal:'http://sopro-backend-env.eba-ghirb5ht.us-east-1.elasticbeanstalk.com/', // aws url (old)
  baseUrlClientPortal:'https://sopro-api.sixlogs.io', // aws url (new)
  production: true,
  firebase: {
    apiKey: "YOUR_APIKEY",
    authDomain: "YOUR_AUTH_DOMAIN",
    databaseURL: "YOUR_DATABASE_URL",
    projectId: "YOUR_PROJECT_ID",
    storageBucket: "universal-angular-85d7e.appspot.com",
    messagingSenderId: "YOUR_MESSAGE_SENDER_ID",
    appId: "YOUR_APPID"
  }
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
